import { CreatePatientAppointment } from './CreatePatientAppointment';

export default CreatePatientAppointment;
